export const tablet_max_width = '600px';